import { oAuthExtensionResultStateSchema, type OAuthCodeResult, type OAuthExtensionResultState } from '../../schemas/oauth';
import { parseRedirectUrl } from './parseRedirectUrl';

export function isExtensionOAuthResult(search: string) {
    try {
        const result = parseRedirectUrl(search);

        return oAuthExtensionResultStateSchema.safeParse(result.state).success;
    } catch {
        return false;
    }
}

export function forwardParamsToExtension(params: OAuthCodeResult) {
    if (!oAuthExtensionResultStateSchema.safeParse(params.state).success) {
        return;
    }

    return new Promise<boolean>(res => {
        const { extensionId, nonce } = params.state as OAuthExtensionResultState;
        // @ts-expect-error
        const port = chrome.runtime.connect(extensionId, { name: nonce });

        function onMessage() {
            port.postMessage(params);
            port.onMessage.removeListener(onMessage);
            res(true);
        }

        port.onMessage.addListener(onMessage);
    });
}
